import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PartySummaryModel } from '../../models/party-summary.model';
@Component({
  selector: 'jsg-action-parties-view',
  templateUrl: './action-parties-view.component.html',
  styleUrls: ['./action-parties-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionPartiesViewComponent implements OnInit {
  @Input() styleOfCause: string;
  @Input() natureOfLitigation: string;
  @Input() displayedColumns: string[];
  @Input() set partySummary(value: PartySummaryModel[]) {
    this._partySummaryData = value;
    this.dataSource = new MatTableDataSource(value || []);
  }
  get partySummary(): PartySummaryModel[] {
    return this._partySummaryData;
  }
  public dataSource: MatTableDataSource<PartySummaryModel>;
  private _partySummaryData: PartySummaryModel[];
  constructor() {}

  ngOnInit(): void {}
}
